// LAYOUT
import '../layout.js';

// GSAP
import { gsap , ScrollSmoother , ScrollTrigger } from "../layout.js";
import { gsapSmoothScrollObj } from "../layout.js";

if (window.innerWidth > 1024) {
  window.addEventListener("DOMContentLoaded", (event) => {
    setTimeout(() => {
      const url = window.location.href;
      var serviceID = url.split("/").pop();
      gsapSmoothScrollObj.scrollTo(serviceID, true, "top-=100");
    }, 1000)
  })

  const serviceAnchor = document.querySelectorAll('.footer__services li a');
  serviceAnchor.forEach((el) => {
    var anchorId = el.getAttribute("href");
    el.addEventListener("click", e => {
      gsapSmoothScrollObj.scrollTo(anchorId, true, "top");
    })
  })
} else {    
  jQuery(function($){
    $(window).on('load', function() {
      var urlHash = window.location.href.split("#")[1];
      if (urlHash &&  $('#' + urlHash).length )
      $('html,body').animate({
          scrollTop: $('#' + urlHash).offset().top - 90
      })
    })
  })

  const links = document.querySelectorAll('.footer__services li a');
  links.forEach(function (elem) {
    elem.addEventListener('click', smoothScroll)
  });
  function smoothScroll(e) {
    e.preventDefault();
    const link = this.getAttribute("href");
    const offsetTop = document.querySelector(link).offsetTop;
    scroll({
      top: offsetTop,
      behavior: "smooth"
    });
  }
}


// BUSINESS MODAL
const panels = document.querySelectorAll(".business-modal__image");
let mediaWidth = gsap.matchMedia();
mediaWidth.add("(min-width: 768px)", () => {
  panels.forEach((panel) => {
    ScrollTrigger.create({
      trigger: panel,
      start: "top top",
      pin: true,
      pinSpacing: false,
    });
  });
});

